import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	ManpowerVendorsApiService,
	CreateVendorBody,
	UpdateVendorBody,
} from '../../../services/manpowerVendorsApi';

const LIST_KEY = ['manpower', 'vendors', 'listing'];

/** Create / update / soft-delete vendor mutations, each invalidating the list on success. */
export const useVendorMutations = () => {
	const queryClient = useQueryClient();
	const invalidate = () => queryClient.invalidateQueries({ queryKey: LIST_KEY });

	const create = useMutation({
		mutationFn: (body: CreateVendorBody) => ManpowerVendorsApiService.createVendor(body),
		onSuccess: invalidate,
	});

	const update = useMutation({
		mutationFn: ({ id, body }: { id: number; body: UpdateVendorBody }) =>
			ManpowerVendorsApiService.updateVendor(id, body),
		onSuccess: invalidate,
	});

	const remove = useMutation({
		mutationFn: (id: number) => ManpowerVendorsApiService.deleteVendor(id),
		onSuccess: invalidate,
	});

	return { create, update, remove };
};
